/**
 * JCTCTAS-152: standalone Vite entry for modules/event-calendar.js -- split
 * out of common.js so it only downloads on a page with a JCTC Event
 * Calendar block (see inc/scripts.php's jctc_block_conditional_assets()).
 * Depends on the `jctc-common` script handle (not just a plain script tag)
 * so `window.jctc_vars` (AJAX nonce/url, used by this module's own
 * getAjaxUrl()/getNonce()) is guaranteed to already exist by the time this
 * runs. See entries/hero-video-viewport.js's own doc comment for why no
 * `$(document).ready()` wrapper is needed.
 */
import initEventCalendars from '../modules/event-calendar.js';

document.addEventListener('DOMContentLoaded', initEventCalendars);
